"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const OfferPricingDetailsItem_1 = require("./OfferPricingDetailsItem");
class OfferPricingDetails {
    constructor({ basicPricings, optionPricings, }) {
        this.toJSON = () => ({
            basicPricings: this.basicPricings.toJSON(),
            optionPricings: this.optionPricings.toJSON(),
        });
        this.basicPricings = basicPricings;
        this.optionPricings = optionPricings;
    }
}
OfferPricingDetails.fromJSON = (json) => {
    const { basicPricings, optionPricings } = Object.assign({}, json);
    if (!Array.isArray(basicPricings))
        throw new Error('.basicPricings must be an array');
    if (!Array.isArray(optionPricings))
        throw new Error('.optionPricings must be an array');
    return new OfferPricingDetails({
        basicPricings: immutable_1.List(basicPricings).map(item => OfferPricingDetailsItem_1.default.fromJSON(item)),
        optionPricings: immutable_1.List(optionPricings).map(item => OfferPricingDetailsItem_1.default.fromJSON(item)),
    });
};
exports.default = OfferPricingDetails;
